import React, { createContext, useContext } from 'react';
import { Report } from '../../types/report.types';
import { ReportActionData } from '../components/ReportActions';

interface ReportContextType {
  // レポート一覧
  availableReports: Report[];

  // 汎用的なレポート関数（ReportActionsコンポーネント用）
  onAddToReport?: (reportId: string, data: ReportActionData) => void;
  onCreateNewReport?: (data: ReportActionData) => void;

  // レポート管理関数（ReportTabContent用）
  onUpdateReport?: (reportId: string, updates: Partial<Report>) => void;
  onDeleteReportElement?: (reportId: string, elementId: string) => void;
  onUpdateReportElement?: (reportId: string, elementId: string, updates: Record<string, unknown>) => void;
  onExportReport?: (reportId: string, format: 'pdf' | 'html' | 'markdown') => Promise<void>;
  onDuplicateReport?: (reportId: string) => void;
  onRenameReport?: (reportId: string, newName: string) => void;

  // Markdownコンテンツの更新
  onContentChange?: (reportId: string, content: string) => void;

  // 要素の追加（複製用）
  onAddElement?: (reportId: string, elementType: string, elementData?: Record<string, unknown>) => void;
}

const ReportContext = createContext<ReportContextType | null>(null);

export const useReportActions = () => {
  const context = useContext(ReportContext);
  if (!context) {
    throw new Error('useReportActions must be used within ReportProvider');
  }
  return context;
};

interface ReportProviderProps {
  children: React.ReactNode;
  value: ReportContextType;
}

export const ReportProvider: React.FC<ReportProviderProps> = ({ children, value }) => {
  return (
    <ReportContext.Provider value={value}>
      {children}
    </ReportContext.Provider>
  );
};